import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/modern/components/ui/dialog-shadcn";
import { Button } from "@/modern/components/ui/button-shadcn";
import cucumberImage from "/assets/cucumber-construction.png";

const SwivuSandBox = ({ onContinueBoard }) => {
  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-2xl sm:rounded-lg w-full p-0 overflow-hidden shadow-lg border-0"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        showCloseButton={false}
      >
        {/* Visual Header */}
        <div className="relative h-48">
          <img
            src={cucumberImage}
            alt="Cucumber Construction demo visualization"
            className="w-full h-full object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
          <div className="absolute left-0 right-0 bg-background h-2 -bottom-1"></div>
        </div>

        {/* Content */}
        <div className="px-8 pb-6 -mt-8 relative">
          <DialogHeader className="space-y-4 text-center border-0">
            <DialogTitle className="text-3xl font-bold tracking-tight text-center animate-fade-in">
              Welcome to Swivu Test Drive
            </DialogTitle>
            <DialogDescription className="text-base leading-normal text-foreground/80 max-w-lg mx-auto text-center animate-fade-in">
              This demo uses sample data from Cucumber Construction so you can explore how Swivu works. Feel free to add, edit, and experiment—nothing here is permanent. When you're ready to see other boards or create your own, click the Swivu logo in the top left corner.
            </DialogDescription>
          </DialogHeader>

          {/* Actions */}
          <div className="flex flex-col items-center mt-8 animate-fade-in">
            <Button
              size="lg"
              onClick={onContinueBoard}
              className="w-full sm:w-auto px-8 h-12 text-base font-semibold shadow-sm"
            >
              Start the Test Drive
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SwivuSandBox;